import { VcSceneProvider } from "@/components/product-waterfall";
import TopNavigation, { NavigationBarRef } from "@/components/top-navigation";
import VerticalScrollview from "@/components/vertical-scrollview";
import { VideoCardScene } from "@akc/biz-api";
import { PullToRefresh } from "antd-mobile";
import React, { useEffect, useRef, useState } from "react";
import { useActivate } from "react-activation";
import ProductList from "./components/ProductList";
import { FollowProductProvider, useResetProductList } from "./hooks/useFollowProduct";
import styles from "./index.module.less";
const FollowProduct: React.FC = () => {
  const resetProductList = useResetProductList();
  const navigationRef = useRef<NavigationBarRef>(null);
  const [showTopButton, setShowTopButton] = useState(false);

  // 处理下拉刷新
  const handleRefresh = async () => {
    await resetProductList();
    return null;
  };

  // 监听滚动事件，控制回到顶部按钮的显示
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowTopButton(true);
      } else {
        setShowTopButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // 组件激活时重置页面标题
  useActivate(() => {
    document.title = "商品收藏";
  });

  // 初始化时设置页面标题
  useEffect(() => {
    document.title = "商品收藏";
  }, []);

  return (
    <FollowProductProvider>
      <div className={styles.container}>
        <TopNavigation
          backgroundColor="#f1f2f5"
          hideSearchIcon={true}
          hideCartIcon={true}
          hideFavoriteIcon={true}
        />
        <div className={styles.followProductWrapper}>
          <PullToRefresh onRefresh={handleRefresh}>
            <VerticalScrollview>
              <VcSceneProvider value={VideoCardScene.videoCardOtherScene}>
                <ProductList
                  onCartChange={navigationRef.current?.triggerAddCartSuccess}
                  provideBackground={false}
                />
              </VcSceneProvider>
            </VerticalScrollview>
          </PullToRefresh>
        </div>
      </div>
    </FollowProductProvider>
  );
};

export default FollowProduct;
